import { render, staticRenderFns } from "./col-skeleton-loader.vue?vue&type=template&id=0b5a6a9f"
import script from "./col-skeleton-loader.vue?vue&type=script&lang=js"
export * from "./col-skeleton-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports